<script>
import { mapActions } from 'vuex';
import i18n from "@/plugins/i18n";

export default {
    props: {
        selectedCompanyId: {
            type: Number,
            required: true
        },

        userId: {
            type: Number,
            required: true
        },

        years: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            items: null,
        }
    },

    computed: {
        headers() {
            return [
                { key: 'date', title: i18n.t('companyProfile.date'), flex: 4 },
                { key: 'name', title: i18n.t('companyProfile.name'), flex: 8 },
            ]
        },
    },

    mounted() {
        this.getItems();
    },

    methods: {
        ...mapActions('company', [
            'getDevNetworks',
        ]),

        getItems() {
            const params = {
                company_id: this.selectedCompanyId,
                is_deleted: false
            }

            this.getDevNetworks(params)
                .then(res => {
                    this.items = res.data;
                })
        },
    }
}
</script>

<template>
    <div class="items">
        <div>
            {{ $t('companyProfile.modal8.text') }}
        </div>

        <div class="item-headers">
            <div v-for="header in headers" :key="header.key" :style="{ flex: header.flex }">
                {{ header.title }}
            </div>
        </div>

        <div class="item" v-for="(item, i) in items" :key="i">
            <select v-model="item.company_development_network_membership_date" :style="{ flex: headers[0].flex }" disabled>
                <option v-for="year in years" :key="year" :value="year">
                    {{ year }}
                </option>
            </select>

            <input type="text" :style="{ flex: headers[1].flex }" v-model="item.company_development_network_name" maxlength="255" disabled/>
        </div>
    </div>
</template>

<style lang='scss' scoped>
.items {
    padding-top: .5em;
    min-height: 100px !important;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
}

.item-headers {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    >div {
        text-align: left;
        margin: .5em;
        color: var(--sustainfinity-navy);
        font-weight: bold;
        font-size: 1.1em;
    }
}

.item {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    align-content: flex-start;
    flex-wrap: wrap;

    >.delete-item-button {
        margin: .5em;
        flex: 1;
        display: flex;
        align-items: center;

        >.cannot-edit {
            font-size: .8em;
            font-style: italic;
            color: var(--invalid-input);
        }

        >button {
            display: flex;
            align-items: center;

            outline: 0;
            border: 0;

            &:focus {
                outline: thin solid lightgray !important;
            }

            >i {
                color: var(--invalid-input);
            }

            &:hover {
                >i {
                    color: var(--invalid-input--hover);
                }
            }

            &:disabled {
                pointer-events: none !important;

                >i {
                    color: gray;
                }
            }
        }

        position: relative;

    }

    >input,
    select {
        text-align: left;
        margin: .5em;
        outline: 0;
        border: 0;
        border-bottom: thin solid lightgray;
        background-color: whitesmoke;

        transition: border-bottom 500ms;

        &:focus {
            border-bottom: thin solid black;
        }

        &:disabled {
            border-radius: .2em;
            background-color: rgb(221, 221, 221);
            cursor: not-allowed;
        }
    }
}
</style>